"use strict";
exports.__esModule = true;
exports.chart_color_orange_500 = {
  "name": "--pf-v5-chart-color-orange-500",
  "value": "#8f4700",
  "var": "var(--pf-v5-chart-color-orange-500, #8f4700)"
};
exports["default"] = exports.chart_color_orange_500;